define.alias("shared/modifiers/focus-on-destruct", "calendar/modifiers/focus-on-destruct");